import type { MutableRefObject } from 'react';
import { useShowList } from '../helpers/mobileView';

export interface UseTemplateListMobileViewParams {
  active: string | undefined;
  activeRef: MutableRefObject<string | undefined>;
  searchPhrase: string;
  loading: boolean;
}

export function useTemplateListMobileView({
  active,
  activeRef,
  searchPhrase,
  loading,
}: UseTemplateListMobileViewParams) {
  return useShowList(active, activeRef, searchPhrase, loading);
}
